// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LKLN","colBig":"styles_colBig__ne22B","colSmall":"styles_colSmall__HAHCb","shopifyNameWrapper":"styles_shopifyNameWrapper__1b_Yj"};